var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.328 9.06h12.673c3.816 0 6.909 3.187 6.909 7.12 0 3.932-3.093 7.12-6.909 7.12H7.115L.328 9.06Z",
    fill: "#4C67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.053 40.8h12.673c3.816 0 6.909-3.187 6.909-7.12 0-3.932-3.093-7.12-6.909-7.12H6.84L.053 40.8Z",
    fill: "#2ACAC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.766.237H27.093c-3.815 0-6.908 3.188-6.908 7.12 0 3.933 3.093 7.12 6.908 7.12h5.886L39.766.237Z",
    fill: "#00CB7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.041 31.978H27.37c-3.816 0-6.909-3.188-6.909-7.12s3.093-7.12 6.909-7.12h5.886l6.786 14.24Z",
    fill: "#7A6FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f7c645c25ad6ac51ab3f7a47674ad944.svg";
export { ForwardRef as ReactComponent };